import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dialog, Button, DialogTitle, DialogActions, DialogContent } from '@material-ui/core'
import './styles.css'

class EasyDialog extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.state = {
      open: false
    }
  }

  static get propTypes() {
    return {
      title: PropTypes.string.isRequired,
      actions: PropTypes.array,
      onAction: PropTypes.func,
      closeAction: PropTypes.string
    }
  }

  handleClick (action) {
    if (typeof this.props.onAction === 'function') {
      if (action) {
        this.props.onAction(action)
      } else {
        this.props.onAction(this.props.closeAction)
      }
    }
  }

  render() {
    const actions = (this.props.actions || []).map(a => {
      return (<Button variant='contained' color='primary' onClick={() => this.handleClick(a)} key={a.title}>{a.title}</Button>)
    })

    return (
      <div>
        <Dialog
          open={true}
          onClose={this.handleClick} >
          <DialogTitle>{this.props.title}</DialogTitle>
          <DialogContent>
            {this.props.children}
          </DialogContent>
          <DialogActions>
            {actions}
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EasyDialog
